/**
 * Positive monthly cost schedules from cash events (timing SoT).
 * Totals stay P&L SoT — events only decide when cash moves.
 */

import { buildCashEvents } from './buildCashEvents.js';
import { materializeCostSchedule } from './materializeFromEvents.js';

/**
 * @returns {{
 *   byCategory: Record<string, number[]>,
 *   totalByMonth: number[],
 *   totals: Record<string, number>,
 *   categories: string[],
 * }}
 */
export function buildCostSchedule(pnl, programme, rawAssumptions = {}) {
  const { events } = buildCashEvents(pnl, programme, rawAssumptions);
  return materializeCostSchedule(events, programme);
}

export function costsPaidInMonth(costSchedule, monthIndex0) {
  const detail = {};
  let total = 0;
  for (const key of costSchedule.categories) {
    const v = costSchedule.byCategory[key][monthIndex0] || 0;
    detail[key] = v;
    total += v;
  }
  return { total, detail };
}
